<template>
  <div class="check-plateform">
    <!--标题-->
    <div class="region-title">查看平台</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="160px">
        <el-form-item label="平台号:">
          <span>{{ basicInfo.code }}</span>
        </el-form-item>
        <el-form-item label="业务:"> {{ basicInfo.salesman ? basicInfo.salesman.fullName : '' }} </el-form-item>
        <el-form-item label="平台名称:"> {{ basicInfo.name }} </el-form-item>
        <el-form-item label="公司名称:"> {{ basicInfo.companyName }} </el-form-item>
        <el-form-item label="手机号:"> {{ basicInfo.phone }} </el-form-item>
        <el-form-item label="公司地区:"> {{ basicInfo.address ? basicInfo.address.province : '' }}{{ basicInfo.address ? basicInfo.address.city : '' }}{{ basicInfo.address ? basicInfo.address.county : ''
        }} </el-form-item>
        <el-form-item label="公司详细地址:"> {{ basicInfo.address ? basicInfo.address.fullAddress : '' }} </el-form-item>
        <el-form-item label="营业执照:">
          <el-image style="max-width:200px" v-if="basicInfo.licenseUrl !== undefined && basicInfo.licenseUrl !== ''" class="yingye" :src="basicInfo.licenseUrl"
            :preview-src-list="[basicInfo.licenseUrl]"></el-image>
        </el-form-item>
        <!-- <el-form-item label="子管理员订单隔离:" prop="subDataIsolation">
          <el-switch v-model="basicInfo.subDataIsolation" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" :disabled="true"></el-switch>
        </el-form-item> -->
        <el-form-item label="平台类型:">
          <el-select v-model="basicInfo.storeTypeBean.id" placeholder="请选择" disabled class="customer-select">
            <el-option :label="item.name" :value="item.id" v-for="item in platformType" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否初创平台:" prop="startups" v-if="basicInfo.storeTypeid == 10010">
          <el-switch v-model="basicInfo.startups" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" :disabled="true"></el-switch>
        </el-form-item>
        <el-form-item label="影像季上传设计版模块:" prop="showProductCenter" v-show="false">
          <el-switch v-model="basicInfo.showProductCenter" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" :disabled="true"></el-switch>
        </el-form-item>
        <el-form-item label="产品中心:" prop="productCenter" v-if="basicInfo.showProductCenter">
          <el-switch v-model="basicInfo.productCenter" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0" :disabled="true"></el-switch>
        </el-form-item>
        <el-form-item label="是否调色:" prop="colorType">
          <el-select v-model="basicInfo.colorType" placeholder="请选择" disabled class="customer-select">
            <el-option :label="item.name" :value="item.id" v-for="item in colorTypes" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="noleft-third-title">
          <div class="third-title"><span>发货信息</span></div>
        </el-form-item>
        <el-form-item label="发货目的地:">
          <div> {{ +basicInfo.sendFlag === 0 ? '平台地址' : +basicInfo.sendFlag === 1 ? '终端客户' : '未定义' }} <!-- <el-radio v-model="basicInfo.sendFlag" disabled :label="0">平台地址</el-radio>
            <el-radio v-model="basicInfo.sendFlag" disabled :label="1">终端客户</el-radio> -->
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" round style="width: 100px;margin-left: 20px;" @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
import { storeTypeGetStoreTypeList, storeQueryByStoreId, checkStoreCode, storeAuditStore } from '@/api/crm'
export default {
  name: 'check-plateform',
  data () {
    return {
      storeMsg: {},
      checkTrueDialog: false,
      checkType: '',
      checkDialog: false,
      basicInfo: {
        address: {
          // fullAddress: ''
        },
        storeTypeBean: {
          id: null
        }
      },
      platformType: [],
      colorTypes: [{
        name: '根据产品设置调色',
        id: 0
      }, {
        name: '全不调色',
        id: 1
      }, {
        name: '全调色',
        id: 2
      }],
      isRepeat: false,
      isCheckedRepeat: false
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    let id = this.$route.query.id
    storeTypeGetStoreTypeList().then((res) => {
      this.platformType = res.data.data
    })
    storeQueryByStoreId(id).then((res) => {
      if (res.data.success) {
        let obj = {}
        obj = res.data.data
        obj.phone = this.$msg.filterBridal(res.data.data.phone)
        obj.sendFlag = obj.sendFlag === undefined ? '0' : obj.sendFlag
        obj.colorType = (obj.colorType === undefined || obj.colorType === null) ? null : obj.colorType
        if (!obj.address) {
          obj.address = {}
        }
        if (res.data.data.storeTypeBean === undefined) {
          obj.storeTypeBean = {
            id: ''
          }
        }
        this.basicInfo = obj
      }
    })
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
